import React, { useContext } from "react";
import { useState, useEffect } from "react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col, Form, InputGroup, Table } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./ViewOffCanvance.css";
import { Context } from "../../../utils/context";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import "react-phone-input-2/lib/bootstrap.css";
import Select from "react-select";
import { CancelButton, SaveButton } from "../../common/Button";
import ModalSave from "../../common/ModelSave";
import { formatDateTime, return_status } from "../../../utils/common";

library.add(fas);

const ViewOffCanvanceReturnOrder = (props) => {
  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    getValues,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const dataToSend = new FormData();
      dataToSend.append("stage", data?.stage?.value);
      const response = await postData(
        `/delivery-boy-manegement/delivery-boy/order/${props.id}`,
        dataToSend,
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  };

  const [data, setData] = useState();
  const getSellerData = async () => {
    const res = await getData(
      `/delivery-boy-manegement/delivery-boy/return-order/${props.id}`,
    );
    setData(res.data);
  };

  useEffect(() => {
    getSellerData();
  }, [props.id]);

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%", height: "auto" }}
        placement={"end"}
        onHide={props.handleClose}
        className="offcan"
      >
        <Container fluid className="tabss-main">
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <Card className="shadow-lg p-3 mb-5 bg-white rounded">
              <Card.Body>
                <Card.Title>
                  <h3>Delivery Boy Return Order</h3>
                </Card.Title>

                <div className="row mt-3">
                  <div className="data table-responsive">
                    <Table striped bordered hover responsive center>
                      <thead>
                        <tr>
                          <th>Product Name</th>
                          <th>Date/Time</th>
                          <th>Invoice No</th>
                          <th>Status</th>
                          <th>Address</th>

                          <th>Amount</th>
                          <th>Payment Mode</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.data?.map((val) => (
                          <tr>
                            <td>{val?.orders_detail?.product?.name}</td>
                            <td>{formatDateTime(val?.updatedAt)}</td>
                            <td>{val?.orders_detail?.invoice_number}</td>
                            <td>
                              {val?.return_status?.id > 5
                                ? "Returned"
                                : val?.return_status?.name}
                            </td>
                            <td>
                              {
                                val?.orders_detail?.order?.users_address
                                  ?.mobile_number
                              }
                              ,
                              {
                                val?.orders_detail?.order?.users_address
                                  ?.address_type
                              }{" "}
                              ,{" "}
                              {val?.orders_detail?.order?.users_address?.floor},{" "}
                              {
                                val?.orders_detail?.order?.users_address
                                  ?.flat_home_bldg
                              }
                              ,{" "}
                              {
                                val?.orders_detail?.order?.users_address
                                  ?.col_land_strt
                              }
                              ,{" "}
                              {
                                val?.orders_detail?.order?.users_address
                                  ?.society_name
                              }
                              ,{" "}
                              {
                                val?.orders_detail?.order?.users_address
                                  ?.area_name
                              }
                            </td>
                            <td>₹ {val?.orders_detail?.total_amount}</td>
                            <td>{val?.orders_detail?.order?.payment_mode}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>{" "}
                    {/* <Pagination_Holder
                        onPageChange={currentPage}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                      /> */}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Offcanvas.Body>

          <div className="mt-5 pb-3">
            <div className="d-flex justify-content-center">
              <CancelButton name={"Back"} handleClose={props.handleClose} />

              {/* <SaveButton name={"save"} handleSubmit={handleSubmit(onSubmit)} /> */}
            </div>
          </div>
        </Container>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default ViewOffCanvanceReturnOrder;
